<template>
  <div
    class="greetings-page"
    v-if="$data.globalData.user"
    :style="{ 'background-image': 'url(' + (mobileView ? greetingInfo.mobile_image : greetingInfo.desktop_image) + ')' }"
  >
    <div class="greetings-text animate-slidein">
      <div class="greeting-inner" v-if="userGameInfo[currentLevel.name]">
        <h1>{{ greetingInfo.message }} {{ editName(fullName) }}!</h1>
        <p>{{ greetingInfo.hint }}</p>
        <img :src="gameContent.badge" style="background-color: transparent;" class="badge" alt="badge" />
        <div class="score-info">
          <img :src="gameContent.logo" alt="logo" />
          <div class="txt">Heildarstig</div>
          <div class="total">{{ userTotalPoints }}</div>
          <div class="divider"></div>
          <div class="out-of">Þú svaraðir {{ Object.values(userGameInfo[currentLevel.name]).filter(Boolean).length }} af {{ Object.values(userGameInfo[currentLevel.name]).length }} spurningum rétt</div>
          <status-bar :answerSheet="Object.values(userGameInfo[currentLevel.name])" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GreetingsMessage',
  props: ['greetingInfo', 'userTotalPoints', 'currentLevel', 'userGameInfo', 'gameContent', 'mobileView'],
  data () {
    return {
      userData: null
    }
  },
  created () {
    if (this.$data.globalData.user) {
      this.userData = this.$data.globalData.user
    }
    if (this.$data.globalData.user) {
      this.fullName = this.$data.globalData.user.name
    }
  },
  methods: {
    proceed () {
      window.location.href = '/spurningar/'
    },
    editName (fullName) {
      fullName = fullName.trim()
      if (fullName.indexOf(' ') !== -1) {
        return fullName.slice(0, fullName.indexOf(' '))
      }
      return fullName
    }
  }
}
</script>

<style lang="scss" scoped>
.greeting-inner {
  opacity: 1;
  max-width: 800px;
  margin: 0 auto;

  -webkit-animation-duration: 1s;
  animation-duration: 0.8s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-name: fadingEffect;
  animation-name: fadingEffect;
  button {
    padding-left: 100px;
    padding-right: 100px;
    @media screen and (min-width: 768px) {
      width: 50%;
    }
  }
  h1 {
    margin: 0 0 8px;
    font-weight: 600;
    font-size: 32px;
    line-height: 38px;
    color: #FFFFFF;
  }
  p {
    margin: 0 auto 34px;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: #FFFFFF;
    max-width: 277px;
  }
  img {
    height: 174px;
    width: auto;
    margin: 0 auto 70px;
    display: block;
  }
  .score-info {
    background: #FFFFFF;
    border-radius: 10px;
    padding: 16px 16px 18px;
    position: relative;
    color: #011627;
    width: 308px;
    margin: auto;
    box-shadow: 0px 0px 50px rgba(0, 0, 0, 0.1);
    img {
      width: 65px;
      height: 65px;
      margin-bottom: 4px;
      position: absolute;
      top: -55px;
      left: 50%;
      transform: translateX(-50%);
    }
    .txt {
      font-weight: 400;
      font-size: 10px;
      line-height: 132%;
    }
    .total {
      font-weight: 600;
      font-size: 42px;
      line-height: 132%;
      margin-bottom: 15px;
    }
    .divider {
      border: 0.5px solid #C4C4C4;
      width: 234px;
      margin: auto;
      margin-bottom: 17px;
    }
    .out-of {
      font-weight: 400;
      font-size: 12px;
      line-height: 132%;
      margin-bottom: 7px;
    }
    .status-page {
      /deep/.status-bar-inner {
        height: 20px;
        width: 20px;
        margin: 0 calc(4px / 2);
      }
    }
  }
}
.animate-svg {
  position: relative;
}
.success-svg {
  animation-duration: 2s;
  animation-fill-mode: both;
  animation-name: firework-zoomin;
  animation-iteration-count: infinite;
}
.level-svg-inner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 9;
  span {
    font-weight: 500;
    font-size: 57px;
    line-height: 63%;
  }
}
@keyframes firework-zoomin {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  75% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
  }
}
.greetings-page {
  text-align: center;
  position: relative;
  padding: 200px 33px 20px;
  height: 100%;
  background-size: cover;
  overflow: auto;
  background-position: center;
}
.silver-court-image {
  svg {
    width: 400px;
    height: 160px;
  }
}
.center-align {
  position: relative;
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}
.gold-court-image {
  svg {
    width: 420px;
    height: 307px;
  }
}
.greeting-image {
  padding-top: 40px;
}
.level-done-img {
  .prime-leftalign {
    width: 350px;
    height: 420px;
    display: inline-block;
    vertical-align: middle;
  }
  .prime-rightalign {
    width: 200px;
    height: 250px;
    display: inline-block;
    vertical-align: middle;
  }
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
.shutter-img {
  padding-top: 50px;
}
.continue-button {
  padding: 90px;
  button {
    padding: 0 10px;
  }
}
.greetings-inner {
  text-align: center;
}
.greetings-text {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-name: greetingFadeIn;
  animation-name: greetingFadeIn;
}
.success {
  // font-family: 'Gothic Bold', sans-serif;
  font-size: 17px;
}
.success-msg {
  font-weight: bold;
  font-size: 36px;
  line-height: 29px;
  color: #696865;
}
@-webkit-keyframes greetingFadeIn {
  0% {
      opacity: 0;
  }
  100% {
      opacity: 1;
  }
}

@keyframes greetingFadeIn {
  0% {
      opacity: 0;
  }
  100% {
      opacity: 1;
  }
}
@media (max-width: 767px) {
  .greetings-page {
    background-size: cover;
    padding-top: 94px;
  }
  .level-done-img {
    padding-top: 7rem;
  }
  .level-svg-inner span {
    line-height: 55%;
  }
  .greetings-text {
    display: block;
  }
  .greeting-inner {
    .score-info {
      .status-page {
        /deep/.status-bar-inner {
          height: 14px;
          width: 14px;
        }
      }
    }
  }
}
</style>